module.exports = __webpack_public_path__ + "src/img/zoomBig.95865231.svg";